/* 🤖 this file was generated by svg-to-ts */
export const siriusCloudCheck: {
  name: 'cloud_check';
  data: string;
} = {
  name: 'cloud_check',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style="display: block;"><path d="M18.53 11.405a.75.75 0 1 0-1.06-1.06l-3.97 3.97-1.72-1.72a.75.75 0 1 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.06 0l4.5-4.5Z" fill="currentColor"/><path fill-rule="evenodd" clip-rule="evenodd" d="M8.14 7.417a8.248 8.248 0 0 0-.52.895 6 6 0 1 0-.87 11.938H15A8.25 8.25 0 1 0 8.14 7.417Zm4.277-1.653A6.75 6.75 0 1 1 15 18.75H6.75a4.5 4.5 0 1 1 .31-8.99A8.25 8.25 0 0 0 6.75 12a.75.75 0 0 0 1.5 0 6.75 6.75 0 0 1 4.167-6.236Z" fill="currentColor"/></svg>`
};
